import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, List, Spin, Typography, Button } from "antd";
import { LeftOutlined, FileTextOutlined } from "@ant-design/icons";
import { useBlogPosts } from "../hooks/useBlogPosts";
import { useFormatDate } from "../hooks/useFormatDate";
import { getBlogMediaPublicUrl } from "../utils/blogMediaUtils";

const { Title, Text } = Typography;

const BLOG_LIST_LIMIT = 500;

export function BlogListPage() {
  const { t } = useTranslation("translation");
  const formatDate = useFormatDate();
  const { posts, loading } = useBlogPosts({
    publishedOnly: true,
    limit: BLOG_LIST_LIMIT,
  });

  return (
    <div style={{ padding: 24, maxWidth: 720, margin: "0 auto" }}>
      <Card>
        <Link to="/dashboard" style={{ marginBottom: 16, display: "inline-block" }}>
          <Button type="text" icon={<LeftOutlined />}>
            {t("blog.backToDashboard")}
          </Button>
        </Link>

        <Title level={2} style={{ marginTop: 0 }}>
          <FileTextOutlined style={{ marginRight: 8 }} />
          {t("blog.title")}
        </Title>

        {loading ? (
          <div style={{ textAlign: "center", padding: 48 }}>
            <Spin size="large" />
          </div>
        ) : posts.length === 0 ? (
          <Text type="secondary">{t("blog.noPosts")}</Text>
        ) : (
          <List
            dataSource={posts}
            renderItem={(p) => {
              const coverUrl = getBlogMediaPublicUrl(p.cover_image_path);
              return (
                <List.Item
                  extra={
                    <Text type="secondary" style={{ fontSize: 13 }}>
                      {formatDate(p.created_at)}
                    </Text>
                  }
                >
                  <List.Item.Meta
                    avatar={
                      coverUrl ? (
                        <img
                          src={coverUrl}
                          alt=""
                          style={{
                            width: 72,
                            height: 54,
                            objectFit: "cover",
                            borderRadius: 4,
                            display: "block",
                          }}
                        />
                      ) : undefined
                    }
                    title={<Link to={`/blog/${p.id}`}>{p.title}</Link>}
                    description={
                      p.excerpt ? (
                        <Text type="secondary">{p.excerpt}</Text>
                      ) : undefined
                    }
                  />
                </List.Item>
              );
            }}
          />
        )}
      </Card>
    </div>
  );
}
